import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
    user: any | null; // TODO: заменить any на тип пользователя
    loading: boolean;
    error: string | null;
    isAuthenticated: boolean;
    token?: string;
}

const initialState: AuthState = {
    user: null,
    loading: false,
    error: null,
    isAuthenticated: false,
    token: undefined,
};

// Асинхронный thunk для получения данных пользователя (сессии)
export const fetchUserSession = createAsyncThunk('auth/fetchUserSession', async (_, thunkAPI) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/user`, {
            method: 'GET',
            credentials: 'include',
        });
        const data = await response.json();
        if (data.user) {
            // return data.user;
            const u = data.user;
            u.addresses = Array.isArray(data.user?.addresses) ? data.user.addresses : [];
            return u;
        } else {
            return thunkAPI.rejectWithValue('Пользователь не найден');
        }
    } catch (err: any) {
        return thunkAPI.rejectWithValue(err.message);
    }
});

const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<any>) => {
            state.user = action.payload;
            state.isAuthenticated = !!action.payload;
            state.error = null;
        },
        setRole(state, action: PayloadAction<string>) {
            if (state.user) {
                state.user.role = action.payload;
                state.user.status = action.payload;
            }
        },
        loginSuccess(state, action: PayloadAction<{ token: string; user: any }>) {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.isAuthenticated = true;
            state.error = null;
            if (state.user) {
                state.user.status = state.user.status || state.user.role;
            }
        },
        clearSession(state) {
            state.user = null;
            state.error = null;
            state.loading = false;
            state.isAuthenticated = false;
            state.token = undefined;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserSession.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchUserSession.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.user = action.payload;
            state.isAuthenticated = true;
            if (state.user) {
                state.user.status = state.user.status || state.user.role;
            }
        });
        builder.addCase(fetchUserSession.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
            state.isAuthenticated = false;
        });
    },
});

export const { setUser, setRole, loginSuccess, clearSession } = AuthSlice.actions;
export default AuthSlice.reducer;
